var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEquals = function SvgEquals(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.125 10c.483 0 .875.298.875.665s-.392.665-.875.665H1.875c-.483 0-.875-.298-.875-.665S1.392 10 1.875 10zM14.125 4.67c.483 0 .875.298.875.665S14.608 6 14.125 6H1.875C1.392 6 1 5.702 1 5.335s.392-.665.875-.665z"
  })));
};
export default SvgEquals;